module.exports = __webpack_public_path__ + "media/images/icons/country_flags/jo-84446d300951d305ca74c33f9389a4d9.svg";